import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CsrProjectRoutingModule } from './csr-project-routing.module';
import { CsrListComponent } from './components/csr-list/csr-list.component';
import { CsrPageComponent } from './components/csr-page/csr-page.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { IonicModule } from '@ionic/angular';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { BsDatepickerModule, DatepickerModule } from 'ngx-bootstrap';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { RemarkComponent } from './components/remark/remark.component';
import { CsrAddComponent } from './components/csr-add/csr-add.component';
import { CsrApprovedComponent } from './components/csr-approved/csr-approved.component';
import { CsrRejectComponent } from './components/csr-reject/csr-reject.component';
@NgModule({
  declarations: [
    CsrListComponent,
    CsrPageComponent,
    RemarkComponent,
    CsrAddComponent,
    CsrApprovedComponent,
    CsrRejectComponent,
  ],
  imports: [
    CommonModule,
    CsrProjectRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    MatDatepickerModule,
    NgxMaterialTimepickerModule,
    IonicModule.forRoot(),
    NgxMatSelectSearchModule,
    DatepickerModule,
    BsDatepickerModule.forRoot(),
    CKEditorModule,
  ],
})
export class CsrProjectModule {}
